import React from 'react';
import {
  IonText,
  IonGrid,
  IonRow,
  IonCol
} from '@ionic/react';
import { Card } from '@tremor/react';
import { extractNumber, formatAmount } from '../../../utils/numberFormat';

const LABEL_WIDTH = '90px';

const PaybillPayment = ({
  amount,
  paybillDetails,
  selectedPlan
}) => {
  const cleanAmount = extractNumber(amount);
  const accountNumber =
    selectedPlan === 'SUB'
      ? paybillDetails.subscriptionAccountNumber
      : paybillDetails.smsAccountNumber;

  return (
    <Card
      style={{
        borderRadius: '10px',
        padding: '1rem',
      }}
    >
      <IonText>
        <h3>Payment Instructions</h3>
      </IonText>

      <IonGrid className="ion-no-padding ion-margin-top ion-margin-bottom">
        {/* Amount */}
        <IonRow className="ion-align-items-center ion-margin-bottom">
          <IonCol size="auto" style={{ width: LABEL_WIDTH }}>
            <IonText className="font-semibold mr-4">Amount</IonText>
          </IonCol>
          <IonCol>
            <IonText>KES {formatAmount(cleanAmount)}</IonText>
          </IonCol>
        </IonRow>

        {/* Paybill */}
        <IonRow className="ion-align-items-center ion-margin-bottom">
          <IonCol size="auto" style={{ width: LABEL_WIDTH }}>
            <IonText className="font-semibold  mr-4">Paybill #</IonText>
          </IonCol>
          <IonCol>
            <IonText>{paybillDetails.paybill} (pay to this paybill number)</IonText>
          </IonCol>
        </IonRow>

        {/* Account Number */}
        <IonRow className="ion-align-items-center">
          <IonCol size="auto" style={{ width: LABEL_WIDTH }}>
            <IonText className="font-semibold  mr-4">Account #</IonText>
          </IonCol>
          <IonCol>
            <IonText>{accountNumber} (use this account number)</IonText>
          </IonCol>
        </IonRow>
      </IonGrid>

      <IonText className="ion-text-center ion-margin-top">
        <p>Once you complete paying, click the “Done” button below.</p>
      </IonText>
    </Card>
  );
};

export default PaybillPayment;
